export enum PassengerType {
    ADULT = 'Adult',
    CHILD = 'Child'
  }
  